import React from "react";
import { isoDaysAgo, today } from "@/lib/format";

const PRESETS = [
  { label: "7D", days: 7 },
  { label: "14D", days: 14 },
  { label: "30D", days: 30 },
  { label: "35D", days: 35 },
];

export default function DateRangePicker({ range, setRange, compare, setCompare }) {
  const applyPreset = (days) => {
    setRange({ start: isoDaysAgo(days - 1), end: today(), preset: days });
  };

  return (
    <div className="w-full lg:w-auto flex flex-col sm:flex-row sm:flex-wrap sm:items-center gap-2.5 sm:gap-3">
      <div className="grid grid-cols-4 sm:flex sm:items-center gap-1 bg-[#14181B] border border-[#242B30] rounded-xl p-1">
        {PRESETS.map((p) => (
          <button
            key={p.days}
            data-testid={`date-preset-${p.days}`}
            onClick={() => applyPreset(p.days)}
            className={`min-h-[40px] px-3 rounded-lg text-xs font-mono font-medium transition-colors ${
              range.preset === p.days
                ? "bg-lime-400 text-[#0A0D0E]"
                : "text-zinc-400 hover:text-white active:bg-[#1B2226]"
            }`}
          >
            {p.label}
          </button>
        ))}
      </div>

      <div className="flex items-center gap-2 bg-[#14181B] border border-[#242B30] rounded-xl px-3 min-h-[44px]">
        <input
          type="date"
          data-testid="date-start"
          value={range.start}
          onChange={(e) => setRange({ ...range, start: e.target.value, preset: null })}
          className="flex-1 min-w-0 bg-transparent text-xs font-mono text-zinc-300 outline-none py-2.5 [color-scheme:dark]"
        />
        <span className="text-zinc-600 shrink-0">→</span>
        <input
          type="date"
          data-testid="date-end"
          value={range.end}
          onChange={(e) => setRange({ ...range, end: e.target.value, preset: null })}
          className="flex-1 min-w-0 bg-transparent text-xs font-mono text-zinc-300 outline-none py-2.5 [color-scheme:dark]"
        />
      </div>

      <button
        data-testid="toggle-compare"
        onClick={() => setCompare(!compare)}
        className={`min-h-[44px] px-4 rounded-xl text-xs font-mono border transition-colors ${
          compare
            ? "bg-lime-400/10 text-lime-400 border-lime-400/30"
            : "bg-[#14181B] text-zinc-400 border-[#242B30] hover:text-white"
        }`}
      >
        vs Previous Period
      </button>
    </div>
  );
}
